import {
  PHONE_CONFIG,
  MIN_INTERNATIONAL_PHONE_LENGTH,
  MAX_INTERNATIONAL_PHONE_LENGTH,
} from "constants/phoneConfig";

const getLengthRequirement = (minLength, maxLength) =>
  minLength === maxLength
    ? `${minLength} digits`
    : `${minLength}-${maxLength} digits`;

export const getInvalidPhoneErrorMessage = (isdCode, countryName) => {
  const config = PHONE_CONFIG[isdCode];
  const resolvedCountryName = countryName || config?.countryName;
  const isdLabel = isdCode || "the selected country";

  if (config) {
    const requirement =
      config.formatHint ||
      getLengthRequirement(config.minLength, config.maxLength);
    const prefix = resolvedCountryName
      ? `Enter a valid ${resolvedCountryName} phone number (${isdLabel})`
      : `Enter a valid phone number for ${isdLabel}`;

    return `${prefix}. Must be ${requirement}.`;
  }

  const fallbackRequirement = getLengthRequirement(
    MIN_INTERNATIONAL_PHONE_LENGTH,
    MAX_INTERNATIONAL_PHONE_LENGTH,
  );
  const prefix = resolvedCountryName
    ? `Enter a valid ${resolvedCountryName} phone number (${isdLabel})`
    : `Enter a valid phone number for ${isdLabel}`;

  return `${prefix}. Must be ${fallbackRequirement}.`;
};

export const sanitizePhone = (phone) =>
  String(phone || "").replace(/[\s\-()]/g, "");

export const validateInternationalPhone = (phone, isdCode) => {
  const sanitized = sanitizePhone(phone);

  if (!sanitized) {
    return false;
  }

  const config = PHONE_CONFIG[isdCode];

  if (config) {
    const regex = new RegExp(`^${config.pattern}$`);
    return (
      regex.test(sanitized) &&
      sanitized.length >= config.minLength &&
      sanitized.length <= config.maxLength
    );
  }

  return (
    /^\d+$/.test(sanitized) &&
    sanitized.length >= MIN_INTERNATIONAL_PHONE_LENGTH &&
    sanitized.length <= MAX_INTERNATIONAL_PHONE_LENGTH
  );
};

export const getPhoneValidationError = (phone, isdCode, countryName) => {
  if (!sanitizePhone(phone)) {
    return null;
  }

  return validateInternationalPhone(phone, isdCode)
    ? null
    : getInvalidPhoneErrorMessage(isdCode, countryName);
};